<template>
  <div class="page" id="page-compare-estimate">

    <element-term-popup v-model="statusPopup" @input="clickPopup" />

    <div
      class="section"
      id="section-compare-estimate-landing"
      :class="['자동차보험', '운전자보험'].indexOf(insureName) !== -1 ? 'only-padding-bottom' : ''"
    >
      <div class="container">
        <template v-if="insureName === '자동차보험'">
          <carousel
            :autoplay="true"
            :autoplayTimeout="5000"
            :items="1"
            :dots="false"
            :nav="false"
            :loop="true"
            v-if="carCarousel"
          >
            <div
              class="landing-carousel-item"
              v-for="n in 4"
              :key="n"
              :class="`main-${n}`"
            >
              <div class="carousel-content">
                <div class="first-line">
                  <img alt="로고" src="/static/carousel-icon.png" />
                  <h3>make sure your sure</h3>
                </div>
                <h1 class="second-line" v-html="mainText[n - 1].title"></h1>
                <p class="devide-line"></p>
                <h3 class="third-line">{{ mainText[n - 1].subTitle }}</h3>
                <p>{{ mainText[n - 1].text }}</p>
              </div> 
            </div>
          </carousel>

          <div class="right-list">
            <h1 :style="isTouchDevice ? 'display: none' : 'display: block'">
              <div class="selectbox">
                <label for="select">
                  {{ insureName }}
                  <span style="color: #000">
                    비교견적
                  </span>
                  <img :src="'/static/compare/arrow.png'" />
                </label>
                <element-combo-box @GetUID="ComboBoxUID" :items="insurances" v-model="insureName" />
              </div>
              <template>쉽고 빠르게</template>
            </h1>
            <p class="right-p" :style="isTouchDevice ? 'display: none' : 'display: block'">내 {{ insureName }}료는 얼마일까?<br/> 한번에 비교하고 더 할인 받으세요.</p>

            <span class="sample-link">
              <span @click="sample_modal_show = true">견적 샘플 보기</span>
              <img src="/static/compare/pencil.png" />
            </span>

            <div class="button-list">
              <router-link
                class="button-apply"
                tag="button"
                :to="{ name: insurances[0].component }"
              >보험료 비교하기</router-link>
              <router-link
                class="button-reservation"
                tag="button" 
                :to="{ name: 'Consultation' }"
              >전화상담 예약</router-link>
            </div>
          </div>
        </template>

        <template v-else-if="insureName === '운전자보험'">
          <carousel
            :autoplay="true"
            :autoplayTimeout="5000"
            :items="1"
            :dots="false"
            :nav="false"
            :loop="true"
            v-if="driverCarousel"
            class="driver-carousel"
          >
            <div
              class="landing-carousel-item"
              v-for="n in 4"
              :key="n"
              :class="`driver-${n}`"
            >
              <div class="carousel-content">
                <div class="first-line">
                  <img alt="로고" src="/static/carousel-icon.png" />
                  <h3>make sure your sure</h3>
                </div>
                <h1 class="second-line">무료로 9개 보험사<br>비교견적을 한눈에 확인!</h1>
                <p class="devide-line"></p>
                <h3 class="third-line">내 운전자보험료는 얼마일까?</h3>
                <p>자동차보험으로는 부족한 안전장치 마련하세요.</p>
              </div> 
            </div>
          </carousel>

          <div class="right-list driver-insurance">
            <h1 :style="isTouchDevice ? 'display: none' : 'display: block'">
              <div class="selectbox">
                <label for="select">
                  {{ insureName }}
                  <span style="color: #000">
                    비교견적
                  </span>
                  <img :src="'/static/compare/arrow.png'" />
                </label>
                <element-combo-box @GetUID="ComboBoxUID" :items="insurances" v-model="insureName" />
              </div>
              <template>쉽고 빠르게</template>
            </h1>
            <p class="right-p" :style="isTouchDevice ? 'display: none' : 'display: block'">내 {{ insureName }}료는 얼마일까?<br/> 한번에 비교하고 더 할인 받으세요.</p>
            <span class="sample-link" :style="isTouchDevice ? 'display: none' : 'display: block'">
              <span @click="$router.push({
                name: 'lifeEstimate',
                query: {
                  ca: true,
                  ins: '운전자-기본',
                  ag: 29,
                  jb: 1,
                  sx: '남자',
                  tb: '1rOIShcOJS5dCozLjS_9_NzS-ANlFyVkWHP_QnuFDOVk'
                }                
              })">보험료 비교표 샘플 보기</span>
              <img src="/static/compare/pencil.png" />
            </span>

            <div class="my-insurance">
              <h3>내 보험료 확인</h3>
              <!-- <p>최근 7일간 <b>21,395</b>명이 확인하셨어요!</p> -->
              <el-form
                :model="formData"
                :rules="rules"
                label-width="70px"
                ref="ruleForm"
              >
                <!-- <el-row :gutter="20">
                  <el-col :md="12" :sm="24">
                    <el-form-item label="이름" prop="name">
                      <el-input placeholder="홍길동" v-model="formData.name" />
                    </el-form-item>
                  </el-col>
                  <el-col :md="12" :sm="24">
                    <el-form-item label="연락처" prop="phoneNumber">
                      <el-input placeholder="010-1234-5678" v-model="formData.phoneNumber" />
                    </el-form-item>
                  </el-col>
                </el-row> -->

                <el-row :gutter="20">
                  <el-col :md="12" :sm="24">
                    <el-form-item label="생년월일" prop="birth">
                      <el-date-picker
                        v-model="formData.birth"
                        value-format="yyyy-MM-dd"
                        ref="birthDate"
                        @focus="focusBirth"
                        @change="changeBirth"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :md="12" :sm="24">
                    <el-form-item label="성별" prop="gender">
                      <el-radio-group v-model="formData.gender">
                        <el-radio-button label="남자"></el-radio-button>
                        <el-radio-button label="여자"></el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item prop="checked">
                  <el-checkbox
                    label="'개인정보수집 및 이용에 대한 동의'"
                    name="checked"
                    v-model="formData.checked"
                    @change="formCheckboxEventHandler"
                  />
                </el-form-item>
              </el-form>

              <div class="button-list">
                <el-button class="button-apply" @click="submitDriver('apply')">보험료 비교표 확인 & 상담</el-button>
                <el-button class="button-reservation" @click="submitDriver('reservation')">즉시 상담</el-button>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <h1>
            <div class="selectbox">
              <label for="select">
                {{ insureName }}<img :src="'../static/expand_more_primary.png'" />
                <span class="sample-link">
                  <template v-if="isTouchDevice">
                    <a v-if="insureName != '자동차보험'" href="../static/견적서예시.html" target="_blank">견적 샘플 보기</a>
                    <a v-if="insureName == '자동차보험'" href="../static/자동차견적서예시.html" target="_blank">견적 샘플 보기</a>
                  </template>
                  <template v-else>
                    <span @click="sample_modal_show = true">견적 샘플 보기</span>
                  </template>
                </span>
              </label>
              <element-combo-box @GetUID="ComboBoxUID" :items="insurances" v-model="insureName" />
            </div>
            <template v-if="!isTouchDevice">비교견적<br/>쉽고 빠르게</template>
          </h1>

          <p style="margin-bottom: 1rem;">내 {{ insureName }}료는 얼마일까?<br class="mobile-br"/> 한번에 비교하고 더 할인 받으세요.</p>

          <p v-if="_isweekdays && _now >= 900 && _now <= 1800" style="margin-top: 1rem;">
            <template v-if="isTouchDevice">즉시 비교견적 상담을 원하시면<br><a class="call_number" href="tel:1668-1100">1668-1100</a>을 눌러주세요.</template>
            <template v-if="!isTouchDevice">즉시상담을 원하시면 <a class="call_number" href="tel:1668-1100">1668-1100</a>으로 전화해주세요.</template>
          </p>
          <div
            class="button-list"
            v-for="(item, index) in insurances"
            :key="index"
          >
            <router-link class="button-apply" v-if="item.name == insureName" tag="button" :to="{ name: item.component }" >비교견적 신청하기</router-link>
            <router-link class="button-reservation" v-if="item.name == insureName" tag="button"  :to="{ name: 'Consultation' }" >전화상담 예약하기</router-link>
          </div>
        </template>    
      </div>
    </div>
    
    <div class="section" id="section-compare-estimate-introduction">
      <div class="container">
        
        <div class="section-header">
          <div class="container">
            <element-tab>
              <template v-if="insureName == '자동차보험'">
                <element-tab-item @click="introductionTab = '가입'" :on="introductionTab == '가입'">가입</element-tab-item>
                <element-tab-item @click="introductionTab = '보상'" :on="introductionTab == '보상'">보상</element-tab-item>
                <element-tab-item @click="introductionTab = '서비스'" :on="introductionTab == '서비스'">자동차보험 혜택</element-tab-item>
                <element-tab-item @click="introductionTab = '제휴보험사'" :on="introductionTab == '제휴보험사'">제휴보험사</element-tab-item>
              </template>
              <template v-else>
                <element-tab-item @click="introductionTab = '가입'" :on="introductionTab == '가입'">가입</element-tab-item>
                <element-tab-item @click="introductionTab = '보상'" :on="introductionTab == '보상'">보상</element-tab-item>
                <element-tab-item @click="introductionTab = '서비스'" :on="introductionTab == '서비스'">서비스</element-tab-item>
                <element-tab-item @click="introductionTab = '제휴보험사'" :on="introductionTab == '제휴보험사'">제휴보험사</element-tab-item>
              </template>
            </element-tab>
          </div>
        </div>

        <div class="section-body">
          <div class="container">
            <div id="introduction-tab-service" v-if="introductionTab == '서비스'">
              <div
                class="subsection"
                id="section-compare-estimate-gifts"
                v-if="['실손의료보험', '암/2대질병 보험', '어린이보험', '태아보험', '정기보험', '종신보험', '화재보험', '연금보험', '치아보험', '치매보험', '펫보험'].indexOf(insureName) == -1"
              >
                <div class="container">
                  <div class="section-title">
                    <p>Gifts</p>
                    <h1>6대 사은</h1>
                  </div>
                  <div class="section-body">
                    <ul :class="isTouchDevice ? 'mobile-list' : ''">
                      <li v-for="(item, index) in gifts" :key="index">
                        <!--<img :src="item.src" ></img>-->
                        <router-link :to="{ name: 'Gift', query: { 'tab': item.name } }">
                          <div class="item" :style="'background-image:url('+item.src+');background-repeat: no-repeat;background-position: center;'"></div>
                        </router-link>
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="subsection" id="section-compare-estimate-guarantee">
                <div class="container">
                  <div class="section-title">
                    <p>Guarantee</p>
                    <h1>5대 보증</h1>
                  </div>
                  <div class="section-body">
                    <ul :class="isTouchDevice ? 'mobile-list' : ''">
                      <li v-for="(item, index) in guarantees" :key="index">
                        <router-link :to="{ name: 'Guarantee', query: { 'tab': item.name } }">
                          <div class="item" :style="'background-image:url('+item.src+');background-repeat: no-repeat;background-position: center;'"></div>
                        </router-link>
                        {{ item.name }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div id="introduction-tab-service" v-if="introductionTab == '가입'">
              <div class="subsection">
                <div class="container">
                  <p class="tab-title">Sign up information</p>
                  <h2 class="tab-subtitle">가입안내</h2>
                  
                  <div class="sign-up-list">
                    <figure
                      v-for="(item, index) in signUpList"
                      :key="index"
                      class="card-list"
                    >
                      <div class="image">
                        <img :src="`/static/compare/info/main${index + 1}.png`" :alt="item.title">
                      </div>
                      <figcaption>
                        <div class="icon" :class="item.link ? 'isRouter' : ''">
                          <img :src="`/static/compare/info/icon${index + 1}.png`" :alt="item.title">
                        </div>
                        <h3><span>{{ item.index }}</span>{{ item.title}}</h3>
                        <p>{{ item.text }}</p>
                      </figcaption>

                      <template v-if="item.link">
                        <a :href="`/guarantee?tab=${item.link.service}`">
                          <span>{{ item.link.text }}</span>
                          <img src="/static/compare/info/link.png" alt="바로가기" />
                        </a>
                      </template>
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="introduction-tab-service"
              v-if="introductionTab == '보상'"
              class="section-compensation-landing"
            >
              <div class="subsection">
                <div class="container">
                  <p class="tab-title">compensation</p>
                  <h2 class="tab-subtitle">보상안내</h2>
                  <!--<p class="subtitle" @click="statusPopup = true">표준 약관 보기</p>-->

                  <div class="compensation-list">
                    <div
                      class="card-list"
                      v-for="(item, index) in compensationList"
                      :key="index"
                      :class="`main-${index + 1}`"
                    >
                      <div class="icon">
                        <img :src="`/static/compare/compensation/icon${index + 1}.png`" :alt="item.title">
                      </div>
                      <div class="desc">
                        <h1>{{ item.title }}</h1>
                        <p class="text" v-html="item.text"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div id="introduction-tab-service" v-if="introductionTab == '제휴보험사'">
              <div class="subsection">
                <div class="container">
                  <div class="section" id="page-aboutus">
                    <p class="tab-title">corporate partnership</p>
                    <h2 class="tab-subtitle">제휴보험사</h2>

                    <div class="section-body" id="alliance_frame" style="padding-bottom:40px;">
                      <div class="container">                          
                        <div v-for="(alliance, index) in allianceList" :key="index">
                          <ul>
                            <li v-for="(item, index2) in alliance" :key="index2">
                              <a
                                :href="item.link"
                                :class="index2 > allianceIndex ? 'none-border-top': ''"
                                target="_blank"
                              >
                                <img :src="item.value" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-top-bar"></div>

        <div class="section-body">
          <div class="container">
            <div id="introduction-tab-service" class="introduction-list">
              <div class="subsection-line">
                <div class="container">
                  <h1>왜 많은 분들이 <b>인슈넷FC를 선택하는 걸까요?</b></h1>

                  <div
                    v-for="(item, index) in introduceList"
                    :key="index"
                    class="introduce-list"
                  >
                    <template v-if="index % 2 === 0 || isTouchDevice">
                      <span class="item-number">{{ item.index }}</span>
                      <div class="image">
                        <img :src="`/static/compare/info/select${index + 1}.png`" :alt="item.title">
                      </div>
                      <div class="desc">
                        <p class="title">{{ item.title }}</p>
                        <h1 v-html="item.subtitle"></h1>
                        <p class="text">{{ item.text }}</p>
                      </div>
                    </template>

                    <template v-else>
                      <div class="desc">
                        <p class="title">{{ item.title }}</p>
                        <h1 v-html="item.subtitle"></h1>
                        <p class="text">{{ item.text }}</p>
                      </div>
                      <div class="image">
                        <img :src="`/static/compare/info/select${index + 1}.png`" :alt="item.title">
                      </div>
                      <span class="item-number">{{ item.index }}</span>
                    </template>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <HomeAdModal :visible="sample_modal_show" :zIndex="1000" ref="estimate_sample_modal" :key="sample_modal_show">
      <div class="modal-header">
        <h1 class="title"><span>견적</span> 샘플 보기</h1>
        <div class="cancelButton" @click="() => {$refs.estimate_sample_modal.close(); sample_modal_show = false;}"></div>
      </div>
      <iframe v-if="insureName != '자동차보험'" :src="`../static/견적서예시.html?in=${insureName}`" style="width: 727px;min-height: 700px;background: white;overflow: auto;"></iframe>
      <iframe v-else src="../static/자동차견적서예시.html" style="width: 727px;min-height: 700px;background: white;overflow: auto;"></iframe>
    </HomeAdModal>

    <el-dialog
      title="개인정보 수집 활용 동의"
      :visible.sync="term.modal"
      :zIndex="1000"
      @close="handleCloseTermModal"
    >      
      <div class="modal-body">
        <h1>보험료 확인 및 상품소개를 위한 <span>개인정보 수집 활용 동의</span></h1>
        <el-row>
          <span>안녕하세요! 고객님이 입력하신 정보는 동의한 범위를 벗어난 목적으로 사용되지 않습니다.</span>
          <el-button
            :type="term.allChecked ? 'primary' : 'info'"
            @click="termAllCheckEventHandler"
            size="small"
            round
          >전체동의</el-button>
        </el-row>

        <div class="term">
          <div class="term-header">
            <h3>(필수) <span>개인(신용)정보</span> 수집, 이용에 대한 동의</h3>
            <el-checkbox v-model="term.checked1" class="large" @change="termCheckboxEventHandler"></el-checkbox>
          </div>
          <el-input
            type="textarea"
            v-html="term.term1"
            autosize
            readonly
          ></el-input>
        </div>

        <!-- <div class="term">
          <div class="term-header">
            <h3>(필수) <span>개인(신용)정보</span> 제공에 대한 동의</h3>
            <el-checkbox v-model="term.checked2" @change="termCheckboxEventHandler"></el-checkbox>
          </div>
          <el-input
            type="textarea"
            v-html="term.term2"
            autosize
            readonly
          ></el-input>
        </div> -->
      </div>

      <div slot="footer">
        <router-link
          class="button-apply"
          tag="button"
          :disabled="!formData.submit"
          :to="{
            name: 'lifeEstimate',
            query: {
              ca: true,
              tb: '1rOIShcOJS5dCozLjS_9_NzS-ANlFyVkWHP_QnuFDOVk',
              ins: '운전자-기본',
              ag: checkAge(formData.birth),
              jb: 1,
              sx: formData.gender,
              birth: formData.birth,
              phoneNumber: formData.phoneNumber,
              name: formData.name
            }
          }"
          @click.native="term.modal = false"
        >보험료 비교하고 상담받기</router-link>
      </div>
    </el-dialog>
    <Footer />
  </div>
</template>

<script>
import { Row, Col, Form, FormItem, Input, RadioGroup, RadioButton, Checkbox, Button, Dialog, DatePicker } from 'element-ui';
import moment from 'moment';
import carousel from 'vue-owl-carousel';
import HomeAdModal from '@/components/Elements/HomeAdModal.vue';
import Footer from "../../view/layout/Footer.vue"

export default {
  components: {
    HomeAdModal,
    carousel,
    Footer,
    [Row.name]: Row,
    [Col.name]: Col,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [DatePicker.name]: DatePicker,
  },
  props: [ 'tab' ],
  data(){
    const emptyInput = (rule, value, cb) => {
      if (value === '' || !value) {
        cb(new Error(rule.message));
      }

      cb();
    }

    return {
      introductionTab: "가입",
      insureName: "",
      statusPopup: false,
      insurances: [
        { name: "자동차보험", src: "../static/home-insurance-1.png", component: "CarInsurance", value: "자동차보험", label: "자동차보험"},
        { name: "운전자보험", src: "../static/home-insurance-2.png", component: "DriverInsurance", value: "운전자보험", label: "운전자보험"},
        { name: "실손의료보험", src: "../static/home-insurance-3.png", component: "EstimateLosslessMedicalInsurance", value: "실손의료보험", label: "실손의료보험"},
        { name: "암/2대질병 보험", src: "../static/home-insurance-4.png", component: "CancerInsurance", value: "암/2대질병 보험", label: "암/2대질병 보험"},
        { name: "어린이보험", src: "../static/home-insurance-5.png", component: "ChildInsurance", value: "어린이보험", label: "어린이보험"},
        { name: "태아보험", src: "../static/home-insurance-6.png", component: "FetalInsurance", value: "태아보험", label: "태아보험"},
        { name: "정기보험", src: "../static/home-insurance-7.png", component: "TermInsurance", value: "정기보험", label: "정기보험"},
        { name: "종신보험", src: "../static/home-insurance-8.png", component: "WholeLifeInsurance", value: "종신보험", label: "종신보험"},
        { name: "화재보험", src: "../static/home-insurance-9.png", component: "FireInsurance", value: "화재보험", label: "화재보험"},
        { name: "연금보험", src: "../static/home-insurance-10.png", component: "PensionInsurance", value: "연금보험", label: "연금보험"},
        { name: "치아보험", src: "../static/home-insurance-11.png", component: "DentalInsurance", value: "치아보험", label: "치아보험"},
        { name: "치매보험", src: "../static/home-insurance-12.png", component: "DementiaInsurance", value: "치매보험", label: "치매보험"},
        { name: "펫보험", src: "../static/home-insurance-13.png", component: "PetInsurance", value: "펫보험", label: "펫보험" }
      ],
      guarantees: [
        { name: "최저 보험료", src: "/static/main/guarantee/minimum.png", width: '59px', height: '63px' },
        { name: "청약철회 환불", src: "/static/main/guarantee/refund.png", width: '68px', height: '62px' },
        { name: "만기완결 알림", src: "/static/main/guarantee/alarm.png", width: '44px', height: '61px' },
        { name: "착오계약 리콜", src: "/static/main/guarantee/recall.png", width: '46px', height: '60px' },
        { name: "24시간 근무", src: "/static/main/guarantee/24hour.png", width: '60px', height: '61px' }
      ],
      gifts: [
        { name: "24시간 주차 알림", src: "/static/main/gift/parking.png", width: '60px', height: '60px' },
        { name: "긴급견인 20km 추가", src: "/static/main/gift/traction.png", width: '61px', height: '54px' },
        { name: "응급치료비 지원", src: "/static/main/gift/emergency.png", width: '54px', height: '51px' },
        { name: "4대 공개 게시판", src: "/static/main/gift/board.png", width: '54px', height: '61px' },
        { name: "SNS 보험정보", src: "/static/main/gift/sns.png", width: '51px', height: '55px' },
        { name: "12개 보험사 비교 견적", src: "/static/main/gift/estimate.png", width: '69px', height: '49px' },
      ],
      products: [
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" },
        { name: "한화손해보험", src: "", memo: "개인용" }
      ],
      faq_data: [],
      openItem: -1,
      comboboxs: [],
      allianceList: {
        ['손해보험사']: [
          { name: '삼성화재', value: '/static/compare/partnership/samsung.png', link: 'https://www.samsungfire.com'},
          { name: '현대해상', value: '/static/compare/partnership/hyundai.png', link: 'https://www.hi.co.kr'},
          { name: 'DB손해보험', value: '/static/compare/partnership/db.png', link: 'https://www.idbins.com'},
          { name: 'KB손해보험', value: '/static/compare/partnership/kb.png', link: 'https://www.kbinsure.co.kr'},
          { name: '메리츠화재', value: '/static/compare/partnership/meritz.png', link: 'https://www.meritzfire.com'},
          { name: '한화손해보험', value: '/static/compare/partnership/hanhwai.png', link: 'https://www.hwgeneralins.com'},
          { name: '롯데손해보험', value: '/static/compare/partnership/lotte.png', link: 'http://www.lotteins.co.kr'},
          { name: '흥국화재', value: '/static/compare/partnership/heungkuk.png', link: 'https://www.heungkukfire.co.kr'},
          { name: 'MG손해보험', value: '/static/compare/partnership/mg.png', link: 'https://www.mggeneralins.com'},
          { name: '라이나생명', value: '/static/compare/partnership/lina.png', link: 'https://www.lina.co.kr'},
          { name: 'DB생명', value: '/static/compare/partnership/db2.png', link: 'https://www.idblife.com'},
          { name: '흥국생명', value: '/static/compare/partnership/heungkuk2.png', link: 'https://www.heungkuklife.co.kr'},
        ],
      },
      sample_modal_show: false,
      mainText: [
        {
          title: '37년동안 30만 이상의<br />고객이 선택한 회사',
          subTitle: '내 자동차보험료는 얼마일까?',
          text: '한번에 비교하고 더 할인 받으세요.' 
        },
        {
          title: '견적은? 싸다! 가입은? 빠르다!<br />관리도? 확실하다!',
          subTitle: '자동차보험 알아서 다! 해주네',
          text: '인슈넷FC' 
        },
        {
          title: '가격은 바람직 가입은 빠름직<br />관리는 믿음직',
          subTitle: '보험 비교견적,',
          text: '인슈넷FC가 가장 좋음직!' 
        },
        {
          title: '견적 비교는 귀찮은데,<br />보험료는 싸게 내고 싶다면?',
          subTitle: '합리적인 귀차니스트를 위한 종합보험서비스,',
          text: '인슈넷FC' 
        },
      ],
      signUpList: [
        {
          index: '01',
          title: '견적서 신청하기',
          text: '견적서를 신청하면 가장 잘 안내해 드릴 수 있는 상담원(IFP)이 배정됩니다.'
        },
        {
          index: '02',
          title: '보험상품 가입설계',
          text: '상담원(IFP)은 고객이 신청한 견적서를 검토해 가장 적합한 가입설계를 합니다.'
        },
        {
          index: '03',
          title: '유리한 보험사 안내',
          text: '가입설계를 기초로 고객에게 가장 유리한 보험사를 안내합니다. 고객이 가입을 희망하면 보험사로 심사 요청합니다.',
          link: {
            text: '최저 보험료 보증 바로가기',
            service: '최저 보험료',
          }
        },
        {
          index: '04',
          title: '자필서명 및 보험료 결제',
          text: '보험사의 승인 후 고객은 보험료를 결제합니다.(상담 내용을 녹취하지 않았거나 자필서명이 필요한 경우에는 인슈넷FC에 팩스로 전송합니다.)',
          link: {
            text: '계약철회 환불 보증 바로가기',
            service: '청약철회 환불'
          }
        },
        {
          index: '05',
          title: '증권 및 영수증 발급',
          text: '보험사에게 보내드리는 보험 증권과 보험료 영수증을 확인하세요. 만약 귀하가 자필서명한 내용과 다르면 바로 인슈넷FC에 연락하세요.',
          link: {
            text: '착오계약 리콜 보증 바로가기',
            service: '착오계약 리콜'
          }
        },
        {
          index: '06',
          title: '보험가입 및 서비스 이용',
          text: '인슈넷FC가 제공하는 5대 보증 & 6대 사은 서비스를 이용하세요. 개인 보험가입자는 15일 이내에 계약을 철회할 수 있습니다.',
        },
      ],
      introduceList: [
        {
          index: '01',
          title: '37 years of history',
          subtitle: '37년 역사의 믿을 수<br /> 있는 회사입니다.',
          text: '인슈넷에프씨는 1985년부터 시작하여 국내 최대 보험대리점으로 안정성이 높은 회사입니다. 국내 유수의 보험사들로부터 우수대리점상을 20차례 넘게 받았습니다. 보험은 인슈넷에프씨처럼 안정성이 높은 대리점에서 가입해야만 안심할 수 있습니다. (매년 보험설계사의 70%가 폐업하면서 고아계약자가 양산되고 있음)'
        },
        {
          index: '02',
          title: 'Savings on insurance premiums',
          subtitle: '보험료를 절약시켜 드립니다.',
          text: '인슈넷에프씨는 보험사에 종속되지 않은 독립대리점이므로 항상 고객의 입장에서 유리한 보험사를 선택해 드릴 수 있습니다. 독립대리점(GA)임을 내세우는 회사들이 출현하고 있지만 대부분은 재벌기업이나 일부 보험사가 보험판매업에 진출하기 위하여 우회적으로 설립한 기업이기 때문에 고객의 이익과는 무관한 영업을 하고 있습니다. 인슈넷에프씨는 보험사로부터 투자나 재정지원을 받지 않은 명실상부한 독립대리점이므로 항상 고객의 입장에서 유리한 보험사를 선택할 수 있습니다.'
        },
        {
          index: '03',
          title: 'accident compensation',
          subtitle: '사고보상을 제대로 받을 수 있습니다.',
          text: '인슈넷에프씨는 고객으로부터 사고상담이나 보험금 청구를 접수받으면 즉시 사고당담 전문가를 배정하여 보상이 완결될 때까지 도와드립니다. 보험금은 은행 예금처럼 쉽게 찾을 수 없습니다. 보험사는 고객이 낸 보험료보다 훨씬 큰 보험금을 지급하므로 까다로울 수 밖에 없고 그래서 고객에게는 전문성을 갖춘 보험대리점의 도움이 꼭 필요합니다. 인슈넷에프씨는 지금 가능한 보험금의 종류와 구비서류를 안내해 드리고, 대형 대리점으로서의 협상력도 발휘하여 사고보상이 빨리 완결되도록 힘써 드립니다.'
        },
        {
          index: '04',
          title: 'insurance design',
          subtitle: '통합적인 보험설계 서비스를 제공합니다.',
          text: '인슈넷에프씨는 손해보험과 생명보험 상품을 통합하여 고객이 필요한 보장에 꼭 맞는 보험상품을 가입시켜 드립니다. 인슈넷에프씨는 고객이 보장받기 원하는 위험, 보장금액, 보험가입 조건, 보험료 수준 등을 파악하여 손해보험과 생명보험 상품을 통합적으로 설계합니다. 이렇게 해야만 보장누락이나 중복 가입을 피할 수 있기 때문입니다. 인슈넷에프씨는 일부 보험사의 짜집기 통합보험이나 다이렉트 보험사의 단종보험이 도달할 수 없는 통합적인 보험설계 서비스를 제공해 드립니다.'
        },
        {
          index: '05',
          title: 'customer protection',
          subtitle: '24시간 365일 고객을 보호합니다.',
          text: '인슈넷에프씨는 24시간, 365일 보험가입, 계약변경, 계약조회, 사고접수, 긴급출동, 주차알림 등의 서비스를 제공합니다.(단, 보험가입 및 계약변경은 영업시간에만 가능) 인슈넷에프씨는 1년의 100%를 고객지원합니다. 하지만 어느 보험사나 설계사는단 23%(계산근거 : 1년 중 토+일+공휴일 114일로 31%쉬고, 평일 퇴근 후 16시간 미근무로 46% 쉬므로 23%)만 고객지원합니다. 인슈넷에프씨는 특히 사고 발생율이 높은 휴일 및 퇴근 후의 77%당 시간을 고객지원 하여 고객이 무방비 상태에 놓이지 않도록 힘쓰고 있습니다.'
        },
        {
          index: '06',
          title: 'information protection',
          subtitle: '고객의 개인정보를 철저히 보호합니다.',
          text: '인슈넷에프씨는 고객의 개인정보보호 정책을 철저히 시행하고 있을 뿐만 아니라, 추가적인 보안조치에도 많은 비용을 투자하고 있습니다. 인슈넷에프씨의 사내에서 특별히 허가 받은 소수 책임자 외에는 고객의 데이터 서버에 접근할 수 없으며, 홈페이지에서도 보안 모듈을 사용하여 정보유출 방지에 만전을 기하고 기하고 있습니다. 인슈넷에프씨는 보안 이슈가 발생하면 보안 책임자가 즉시 전사원을 교육하며, 별도 독립된 데이터 센터에서 첨단의 보안 시스템을 24시간 가동하고 있습니다'
        },
        {
          index: '07',
          title: 'accident compensation',
          subtitle: '5대 보증, 6대 사은 서비스를 제공합니다.',
          text: '인슈넷에프씨는 5대 보증과 6대 사은 등 다른 보험대리점, 설계사 및 보험사가 따라올 수 없는 서비스를 고객에게 제공합니다. 5대 보증은 최저보험료, 계약철회 환불, 만기완결 알림, 착오계약 리콜, 24시간 근무 등이며 6대 사은은 24시간 주차알림, 긴급견인 20~50Km 추가, 응급치료비 지원, 4대공개 게시판, 12개 보험사 보험료 비교견적, SNS 보험 정보 등 입니다. 인슈넷에프씨는 고객의 위험관리자로서 항상 본연의 역할을 다하겠으며, 고객에게 도움이 되는 새로운 서비스를 개발하는데 게을리하지 않겠습니다.'
        },
      ],
      compensationList: [
        {
          title: '24시간 365일 보상접수',
          text: '고객님이 가입한 보험약관에서 보험금을 지급하는<br />사유에 해당 여부를 속히 안내해 드립니다.<br />(참고: 인슈넷FC가 아닌 곳에서 가입한 계약은 서비스<br /> 대상에서 제외됨.)'
        },
        {
          title: '보험금 청구절차',
          text: '보험금 지급 사유에 해당하면 고객님께 보험금 청구절차와<br /> 구비서류를 안내해 드립니다. 보험금은 피보함자가<br /> 보험자에 직접 청구하는 것이 원칙이며,<br />구비서류는 보험사와 보험금의 종류에 따라 달라집니다.'
        },
        {
          title: '보험금 수령 적정성 확인',
          text: '보험사로부터 수령한 보험금이 보험약관의 지급<br />기준에 안맞는다고 생각되면 보험사가 제출한<br />구비서류를 갖추어 인슈넷FC 홈페이지 게시판<br />또는 1668-1100으로 문의하여 주십시오.<br />전문가가 고객의 입장에서 검토하고, 필요하다면<br />보험사의 보상과에 문의하여 해결해 드리겠습니다.'
        },
        {
          title: '분쟁방지 및 민원안내',
          text: '보험금을 청구하는 과정이나 지급받은 보험금과<br />관련하여 이의가 있으시면 언제든지 인슈넷FC<br />홈페이지 게시판 또는 1668-1100으로<br />연락해주십시오. 고객님 입장에서 검토한 후<br />보험사의 보상과의 협의하여 원만히 처리하도록<br />힘써 드리겠습니다. 보험금 분쟁은 가급적<br />소송보다는 중재를 받는 것이 고객님께<br />시간과 비용 측면에서 유리합니다.'
        },
      ],
      isTouchDevice: this.$store.state.config.isTouchDevice,
      allianceIndex: this.$store.state.config.isTouchDevice ? 3 : 5,
      carCarousel: false,
      driverCarousel: false,
      formData: {
        name: '',
        phoneNumber: '',
        birth: '1980-01-01',
        gender: '남자',
        checked: false,
        submit: false
      },
      rules: {
        // name: [{ validator: emptyInput, message: '이름을 입력해주세요', trigger: 'blur' }],
        // phoneNumber: [{ validator: emptyInput, message: '연락처를 입력해주세요', trigger: 'blur' }],
        birth: [{ validator: emptyInput, message: '생년월일을 입력해주세요', trigger: 'change' }],
        gender: [{ validator: emptyInput, message: '성별을 선택해주세요', trigger: 'change' }],
        checked: [{ validator: emptyInput, message: '개인정보 수집 및 이용, 제공에 대한 동의를 해주세요', trigger: 'change' }],
      },
      term: {
        modal: false,
        allChecked: false,
        checked1: false,
        checked2: true,
        submit: false,
        term1: "당사 및 당사 업무수탁자는 '개인정보보호법', '신용 정보의 이용 및 보호에 관한 법률'에 따라 귀하의 개인(신용)정보를 다음과 같이 수집, 이용하고자 합니다.<br />*수집 이용 목적: 보험료확인, 보험료산출결과안내, 상품 서비스 소개 및 판매, 사은 판촉행사 안내, 시장조사<br />*보유 및 이용 기간: 동의일로부터 3년",
        term2: '당사는 개인정보보호법, 신용정보의 이용 및 보호에 관한 법률에 따라 귀하의 개인 (신용)정보를 다음과 감이 제3자에게 제공하고자 합니다.<br />제공받는 자: 인슈넷에프씨 보험설계사'
      },
      estimate: {
        modal: false,
        insurance: [],
        data: null,
      }
    }
  },
  computed: {
    _now() {
      return moment().format("HHmm")
    },
    _isweekdays() {
      return moment().day() > 0 && moment().day() < 6
    }
  },
  watch: {
    '$route' (n) {
      if(n.name == "CompareEstimate") {
        if(this.$route.query.tab) {
          this.insureName = this.$route.query.tab;
        }
        else {
          this.insureName = "자동차보험";
        }
      }
    },
    'insureName' () {
      if(this.insureName != this.$route.query.tab)
        this.$router.replace({ query: { tab : this.insureName}})
      
      this.$nextTick(() => {
        if (this.insureName === '운전자보험') {
          this.carCarousel = false;
          this.driverCarousel = true;
        } 
        
        if (this.insureName === '자동차보험') {
          this.carCarousel = true;
          this.driverCarousel = false;
        }
      })
    },
    'formData.phoneNumber'(value) {
      let phoneNumber = value;

      if (value.length > 13) {
        phoneNumber = phoneNumber.substr(0, 13);
      } else {
        phoneNumber = value.replace(/[^0-9]/g, '').replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3').replace("--", "-");
      }

      this.formData.phoneNumber = phoneNumber;
    },
  },
  created() {
    this.updatePage(1);
    //this.$store.commit( "elementModal/SET_ITEM", { elementId: "globaltest" });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEventHandler);
  },
  mounted() {
    this.insureName = (this.$route.query.tab || '자동차보험');
    window.addEventListener('resize', this.resizeEventHandler);
  },
  methods: {
    fetchTab () {
      if(this.$route.query.tab) {
        this.insureName = this.$route.query.tab;
      }
      else {
        this.insureName = "자동차보험";
      }
    },
    clickPopup() {
      this.statusPopup = false;
    },
    updatePage(page){
      this.$data.currentPage = page;

      this.$store.dispatch( "post/getItems", { page: 1, size: 5, post_type: "faq_auto" } ).then( res => {
        this.faq_data = res.data.data.items;
      });

    },
    ComboBoxItemClick(e) {
      this.insureName = e.name;
    },
    ComboBoxUID(value) {
      this.comboboxs.push(value)
    },
    resizeEventHandler() {
      const { userAgent } = window.navigator;
      const allianceEl = document.querySelectorAll('.none-border-top');

      for (let i = 0; i < allianceEl.length; i++) {
        allianceEl[i].classList.remove('none-border-top');
      }

      this.isTouchDevice = /iPhone|iPad|iPod|Android/i.test(userAgent);
      this.allianceIndex = 3;
    },
    formCheckboxEventHandler(value) {
      if (value) {
        return this.term.modal = true;
      }
      
      this.term = {
        ...this.term,
        checked1: false,
        checked2: false,
        allChecked: false,
      }
      this.formData.submit = false;
    },
    termAllCheckEventHandler() {
      const { checked1, checked2 } = this.term;
      const { name, phoneNumber } = this.formData;
      let checked = false;
      
      if (!checked1 && !checked2) {
        checked = true;
      }

      if (checked1 && checked2) {
        checked = false;
      }

      if (checked1 !== checked2) {
        checked = true;
      }

      this.term.checked1 = checked;
      this.term.checked2 = checked;
      this.term.allChecked = checked;
      this.formData.checked = checked;

      // if (name !== '' && phoneNumber !== '') {
      this.formData.submit = checked;
      // }
    },
    termCheckboxEventHandler() {
      const { checked1, checked2 } = this.term;
      const { name, phoneNumber } = this.formData;
      const checked = checked1 && checked2;
      
      this.term.allChecked = checked;
      this.term.submit = checked;
      this.formData.checked = checked;

      // if (name !== '' && phoneNumber !== '') {
      this.formData.submit = checked;
      // }
    },
    handleCloseTermModal() {
      this.formData.checked = this.term.allChecked;
    },
    checkAge(birth) {
      const _birth = moment(birth).format('YYYY.MM.DD');
      const birthYY = _birth.substr(0, 4);
      const birthMD = _birth.substr(4);
      
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      let month = (currentDate.getMonth() + 1);
      let day = currentDate.getDate();
      month = month < 10 ? '0' + month : String(month);
      day = day < 10 ? '0' + day : String(day);
      const md = month + day;

      let age = year - birthYY;

      if (md < birthMD) {
        age = age - 1
      }
      
      return age;
    },
    submitDriver(type) {
      this.$refs.ruleForm.validate((valid) => {
        this.formData.submit = valid;

        const options = {
          apply: {
            name: 'lifeEstimate',
            query: {
              ca: true,
              tb: '1rOIShcOJS5dCozLjS_9_NzS-ANlFyVkWHP_QnuFDOVk',
              ins: '운전자-기본',
              ag: this.checkAge(this.formData.birth),
              jb: 1,
              sx: this.formData.gender,
              birth: this.formData.birth,
              phoneNumber: this.formData.phoneNumber,
              name: this.formData.name
            }
          },
          reservation: {
            name: 'Consultation',
            query: {
              name: this.formData.name,
              phoneNumber: this.formData.phoneNumber,
              isDateTime: true
            }
          }
        }[type];

        if (!valid) {
          return false;
        }

        this.$router.push(options);

        this.$store.commit("elementModal/CLEAR_ITEMS");
      })
    },
    focusBirth() {
      const $target = this.$refs.birthDate;
      const $input = $target.$children[0];
      const $el = $input.$el;

      $el.addEventListener('keyup', () => {
        const value = $input.value;
        let birth = value;

        if (value.length > 10) {
          birth = value.substr(0, 10);
        } else {
          birth = value.replace(/[^0-9]/g, '').replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
        }

        $target.userInput = birth;
      });

    },
    changeBirth() {
      const $target = this.$refs.birthDate;
      const pattern = /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/;

      if (!pattern.test($target.value)) {
        this.formData.birth = '1980-01-01';
      }
    },
  },
}
</script>
<style lang="scss">
  .subsection-line{
    & > .container {
      width: 100%;
      max-width: 1000px;
      margin: 0 auto;
    }
          

    padding: 2*$unit 1*$unit;
    background-color: $color-white;
    h2{
      font-size: 2*$unit;
      text-align: center;
      margin: 2*$unit 0 5*$unit 0;
      .index{
        color: #174be6;
        margin: 0 $unit;
      }
    }

    .subtitle{
      @include absolute( right );
      margin-top: $unit;
      font-size: $size-medium;
      color: $color-schema;
    }

    ol{
      display: flex;
      flex-wrap: wrap;
      li{
        width: 100%;
        color: $color-black-soft;
        padding-bottom: 1*$unit;
        margin-bottom: 2*$unit;
        border-bottom: solid 1px $color-gray;
        h3{
          margin-bottom: 2*$unit;
          font-size: $size-large;
          color: $color-black;
          .index{
            color: #174be6;
            margin-right: $unit;
          }
        }
        button{
          height: 50px;
          line-height: 50px;
          margin-top: $unit;
          background-color: $color-schema-bright;
          color: $color-schema;
        }
      }
    }

    .section-list{
      ul{
        @include column( "& > li", 2, 2% );
        li{
          border: solid 1px $color-gray;
          padding: .8*$unit;
          .item{
            width: 5*$unit;
            height: 5*$unit;
            float: left;
            background: $color-gray;
            margin-right: $unit;
            display: none;
            div{
            }
          }
          p{
            color: $color-black;
            margin-top: .8*$unit;
          }
          color: $color-black-soft;

          img{
            float: right;
            margin-top: -0.5*$unit;
            margin-right: .5*$unit;
            width: .5*$unit;
          }
        }
      }
    }
  }
  .call_number {
    text-decoration: underline;
    text-decoration-color: #164be6;
    font-size: 25px;
    font-weight: bold;
    color:#164be6;
    white-space: nowrap;
  }
  .mobile-list{
    white-space: pre-wrap !important;
    text-align: left !important;
    & > li {
      margin: 1rem !important;
    } 
  }
  #alliance_frame {
    margin: auto;
    ul {
      text-align: center;
      margin-top:20px;
      padding: 0 0.5rem;
      li {
        display: inline-block;
        text-align: center;

        &:nth-child(1n + 1) {
          & > a {
            border-right: unset;
            // border-left: unset;
          }
        }
        &:nth-child(6n) {
          & > a {
            border-right: 1px solid #e6e6e6;
          }
        }

        & > a {
          width: 100%;
          display: inline-block;
          background: white;
          border: 1px solid #e6e6e6;
          // border-radius: 4px;
          height: 7rem;
          line-height: 6rem;
          padding: 0.25rem;
          box-sizing: border-box;
          &.none-border-top {
            border-top: unset;
          }
          & > img {
            display: inline-block;
            vertical-align: middle;
            max-height: 100%;
          }
        }
        @media screen and (min-width: 1000px) {
          width: 14.67%;
        }
        @media screen and (max-width: 999px) {
          width: 25% !important;
         
          text-align: center;
          padding: 0 0.5rem;
        }
        @include media-mobile {
          padding: 0;
          &:nth-child(6n) {
            > a {
              border-right: unset;
            }
          }
          &:nth-child(4n) {
            > a {
              border-right: 1px solid #e6e6e6;
            }
          }
        }        
      }
    }
  }
  .sample-link {
    font-size: 1rem;
    line-height: 42px;
    display: block;
    height: 47px;
    position: absolute;
    
    width: auto;
    
    z-index: 100;
    @media screen and (min-width: 769px) {
      top: 0;
      right: -110px;
    }
    @media screen and (max-width: 768px) {
      padding-left: 0.5rem;
      bottom: -11.5rem;
    }
    @media screen and (max-width: 480px) {
      padding-left: 0.5rem;
      bottom: -3.5rem;
    }
    & > * {
      cursor: pointer;
      border-bottom: 1px solid #164be6;
    }
  }
  iframe {
    &::-webkit-scrollbar {
      width: 11px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #174de5;
    }
    &::-webkit-scrollbar-track {
      background-color: #e7edfc;
    }
  }
  .modal-header {
    background-color: #fff;
    color: white;
    line-height: 1rem;
    padding: 2.5rem;
    text-align: center;

    & > h1 {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 1.3rem;
      line-height: 1.8;
      font-weight: bold;
      color: #000;
      border-bottom: 1px solid #e7edfc;
      display: inline-block;
      span {
        color: #174be6;
      }
    }
    & > .cancelButton {
      width: 2.85rem;
      height: 2.85rem;
      background-image: url(/static/modal/close_btn.png);
      background-size: 1.2rem;
      background-repeat: no-repeat;
      background-position: center right;
      font-size: 16px;
      font-weight: 600;
      position: absolute;
      right: 20px;
      top: 2rem;
      cursor: pointer;
    }
  }
</style>